import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const SESSION_STORAGE_KEY = 'air/mobileAppBanner/sessionDismissed';

type MobileAppBannerSessionState = {
  isDismissed: boolean;
  dismiss: () => void;
};

/** Dismissal persists per session (sessionStorage), so the banner returns on the user's next visit. */
export const useMobileAppBannerSessionStore = create<MobileAppBannerSessionState>()(
  persist(
    (set) => ({
      isDismissed: false,
      dismiss: () => set({ isDismissed: true }),
    }),
    {
      name: SESSION_STORAGE_KEY,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
